import actionTypes from "../actions/actionTypes";

const initialState = {
  //Poll Management States :
  editPollResponseData: null,
  copyPollResponseData: null,
  distributePollResponseData: null,
  teanantPollUsers: null,
  pollUserGroups: null,
  pollPreviewList: null,
  pollLoading: null,
  unlockPollLoading: null,
  lockPollLoading: null,
  deletePollLoding: null,
  distributePollLoading: null,
  isPollNameExistLoading: null,

  //Forum Area States :
  createForumTopicResponseData: null,
  editForumTopicResponseData: null,
  createForumTOpicLoading: null,
  createForumThreadResponseData: null,
  forumTopics: null,
  createForumThreadLoader: null,
  forumThreads: null,
  createForumCommentLoader: null,
  forumTOpicLoading: null,

  //Moderate Contribution States :
  isViewComment: 0,
  shotClassFormData: null,
};

const socialReducer = (state = initialState, action) => {
  // debugger;
  const { type, payload } = action;
  switch (type) {
    case actionTypes.socialTypes.EDIT_POLL_RESPONSE:
      return { ...state, editPollResponseData: payload };
    case actionTypes.socialTypes.COPY_POLL_RESPONSE:
      return { ...state, copyPollResponseData: payload };
    case actionTypes.socialTypes.DISTRIBUTE_POLL_RESPONSE:
      return { ...state, distributePollResponseData: payload };
    case actionTypes.socialTypes.GET_TENANT_POLL_USERS:
      return { ...state, teanantPollUsers: payload };
    case actionTypes.socialTypes.GET_POLL_USER_GROUP:
      return { ...state, pollUserGroups: payload };
    case actionTypes.socialTypes.GET_POLL_PREVIEW_LIST:
      return { ...state, pollPreviewList: payload };
    case actionTypes.socialTypes.SET_POLL_LOADER:
      return { ...state, pollLoading: payload };
    case actionTypes.socialTypes.SET_UNLOCK_POLL_LOADER:
      return { ...state, unlockPollLoading: payload };
    case actionTypes.socialTypes.SET_LOCK_POLL_LOADER:
      return { ...state, lockPollLoading: payload };
    case actionTypes.socialTypes.SET_DELETE_POLL_LOADER:
      return { ...state, deletePollLoding: payload };
    case actionTypes.socialTypes.FORUM_AREA.CREATE_FORUM_TOPIC_RESPONSE:
      return { ...state, createForumTopicResponseData: payload };
    case actionTypes.socialTypes.FORUM_AREA.CREATE_FORUM_TOPIC_LOADING:
      return { ...state, createForumTOpicLoading: payload };
    case actionTypes.socialTypes.FORUM_AREA.EDIT_FORUM_TOPIC_RESPONSE:
      return { ...state, editForumTopicResponseData: payload };
    case actionTypes.socialTypes.FORUM_AREA.CREATE_FORUMT_THREAD:
      return { ...state, createForumThreadResponseData: payload };
    case actionTypes.socialTypes.FORUM_AREA.FORUM_TOPICS:
      return { ...state, forumTopics: payload };
    case actionTypes.socialTypes.FORUM_AREA.CREATE_FORUM_THREAD_LOADER:
      return { ...state, createForumThreadLoader: payload };
    case actionTypes.socialTypes.FORUM_AREA.FORUM_THREADS:
      return { ...state, forumThreads: payload };
    case actionTypes.socialTypes.FORUM_AREA.CREATE_FORUM_COMMENT_LOADER:
      return { ...state, createForumCommentLoader: payload };
    case actionTypes.socialTypes.FORUM_AREA.VIEW_COMMENTS:
      return { ...state, isViewComment: payload };
    case actionTypes.socialTypes.FORUM_AREA.SHOTCLASS_FORM_DATA:
      return { ...state, shotClassFormData: payload };
    case actionTypes.socialTypes.SET_DISTRIBUTE_POLL_LOADER:
      return { ...state, distributePollLoading: payload };
    case actionTypes.socialTypes.SET_IS_POLL_NAME_EXIST_LOADER:
      return { ...state, isPollNameExistLoading: payload };
    case actionTypes.socialTypes.FORUM_AREA.SET_FORUM_TOPIC_LOADER:
      return { ...state, forumTOpicLoading: payload };
    default:
      return state;
  }
};

export default socialReducer;
